import { createApp } from "vue";
import App from "./App.vue";

/* import Firebase */
import * as firebase from "firebase/app";
import "firebase/analytics";

let test = false;

var firebaseConfig = {
  apiKey: "AIzaSyAG__S2eNjWv4Urj8CdSec1-WfwpGqzZGM",
  authDomain: "noelrecords-apps.firebaseapp.com",
  databaseURL: "https://noelrecords-apps.firebaseio.com",
  projectId: "noelrecords-apps",
  storageBucket: "noelrecords-apps.appspot.com",
  messagingSenderId: "661496365597",
  appId: "1:661496365597:web:cd86c914cb50da0fd8fcf4",
  measurementId: "G-2GFE0YZ8EL",
};

if (!test) {
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
}

createApp(App).mount("#app");
